import { Outlet } from "react-router-dom"

import PageContainer from "components/PageContainer/PageContainer"

const ErrandPageContainer = () => {
  return (
    <PageContainer>
      <Outlet />
    </PageContainer>
  )
}

export default ErrandPageContainer
